import { Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';

export const SentryRoute = Sentry.withSentryReactRouterV6Routing(Route);
